import axios from "axios";
import LocalStorage from "./LocalStorage";

const axiosMercury = () => {
  let value = LocalStorage.AUTH_TOKEN || localStorage.getItem("AUTH_TOKEN");
  return axios.create({
    baseURL: process.env.REACT_APP_MERCURY_API_BASE_URL,
    headers: {
      Authorization: `Bearer ${value}`,
    },
  });
};

export default axiosMercury;
